const ProgressBarConfig = {
  animation: 1,
  terms: 2,
  checklist: 3,
  name: 4,
  country: 5,
  checklist2: 6,
  integrationsCalendar: 7,
  integrationsDesktop: 8,
  integrationsHealth: 9,
  integrationsChecklist: 10,
  customizeElements: 11,
};

export default ProgressBarConfig;
